<template>
  <div>
    <HorizontalField>
      <template v-slot:label>
        <span class="label">13. Nov.</span>
      </template>
      <label><input type="checkbox" name="lunch_1" checked /> Lunch</label>
      <label><input type="checkbox" name="dinner_1" checked /> Dinner</label>
    </HorizontalField>
    <HorizontalField>
      <template v-slot:label>
        <span class="label">14. Nov.</span>
      </template>
      <label><input type="checkbox" name="lunch_2" checked /> Lunch</label>
      <label><input type="checkbox" name="dinner_2" checked /> Dinner</label>
    </HorizontalField>
    <HorizontalField>
      <template v-slot:label>
        <span class="label">15. Nov.</span>
      </template>
      <label><input type="checkbox" name="lunch_3" checked /> Lunch</label>
    </HorizontalField>
  </div>
</template>

<script>
import HorizontalField from "@/components/HorizontalField";
export default {
  name: "FoodSelection",
  components: { HorizontalField },
};
</script>

<style scoped>
label {
  margin-right: 12px;
}
</style>
